import { Component } from '@angular/core';
import { combineLatest, filter, map, Observable, of, switchMap } from 'rxjs';
import { ApiPattern } from 'src/app/models_new/classes/api-models/ApiPattern';
import { ApiScene } from 'src/app/models_new/classes/api-models/ApiScene';
import { SimulationWizardDataService } from '../../simulation-wizard-data.service';
import { ApiStrategy } from 'src/app/models_new/classes/api-models/ApiStrategy';
import { toRequestState } from 'src/app/data-request/operators';
import { DataRequestState } from 'src/app/data-request/model';

@Component({
  selector: 'app-simulation-wizard-summary',
  templateUrl: './simulation-wizard-summary.component.html',
  styleUrls: ['./simulation-wizard-summary.component.scss'],
})
export class SimulationWizardSummaryComponent {
  currentPattern: ApiPattern;
  currentHw: ApiScene;
  currentSw: ApiStrategy;
  init$: Observable<DataRequestState<boolean>>;
  stagedPatterns: ApiPattern[];
  stagedHardware: ApiScene[];
  stagedSoftware: ApiStrategy[];
  stagedSoftwarePresets: ApiStrategy[];

  constructor(private simWizardDataService: SimulationWizardDataService) {
    this.init$ = this.simWizardDataService.newSummaryInit.pipe(
      filter(Boolean),
      switchMap((_) =>
        combineLatest([
          combineLatest([
            of(this.simWizardDataService.zimWizard.patterns),
            this.simWizardDataService.patterns$,
          ]),
          combineLatest([
            of(this.simWizardDataService.zimWizard.hardwares),
            this.simWizardDataService.hardwares$,
          ]),
          combineLatest([
            of(this.simWizardDataService.zimWizard.softwares),
            this.simWizardDataService.softwares$,
          ]),
          combineLatest([
            of(this.simWizardDataService.zimWizard.softwarePresets),
            this.simWizardDataService.softwarePresets$,
          ]),
        ])
      ),
      map(([patterns, hw, sw, presets]) => {
        this.stagedPatterns = patterns[1]
          .filter((f) => patterns[0].map((m) => m.id).includes(f.id))
          .map((m) => new ApiPattern(m));
        this.stagedHardware = hw[1]
          .filter((f) => hw[0].map((m) => m.id).includes(f.id))
          .map((m) => new ApiScene(m));
        this.stagedSoftware = sw[1]
          .filter((f) => sw[0].map((m) => m.id).includes(f.id))
          .map((m) => new ApiStrategy(m));
        this.stagedSoftwarePresets = presets[1]
          .filter((f) => presets[0].map((m) => m.id).includes(f.id))
          .map((m) => new ApiStrategy(m));

        this.currentPattern = this.stagedPatterns[0];
        this.currentHw = this.stagedHardware[0];
        this.currentSw =
          this.stagedSoftware[0] || this.stagedSoftwarePresets[0];
        return true;
      }),
      toRequestState()
    );
  }
}
